import { ChangeEvent, JSX, useContext, useState } from "react";
import { MemberSetModel } from ".";
import ResourceUpdateModel from "../resources/resourceUpdateModel";
import { QESButton, QESCheckbox } from "@app/shared/qes-standards";
import { FlyoutContext, FlyoutFooter } from "@app/shared/Flyouts";

interface MemberSetEditResourceFlyoutProps {
  onSubmit: (resourceUpdateModel: ResourceUpdateModel) => void;
  memberSet: MemberSetModel;
}

const MemberSetEditResourceFlyout = (props: MemberSetEditResourceFlyoutProps): JSX.Element => {
  const [canSubmit, setCanSubmit] = useState(false);
  const [resourceName, setResourceName] = useState(props.memberSet.resource.name);
  const [resourceDescription, setResourceDescription] = useState(props.memberSet.resource.description);
  const [resourceIsPrivate, setResourceIsPrivate] = useState(props.memberSet.resource.isPrivate);
  const flyoutContext = useContext(FlyoutContext);

  const handleSubmit = () => {
    const updateModel = {
      description: resourceDescription,
      isPrivate: resourceIsPrivate,
      name: resourceName,
    };
    props.onSubmit(updateModel);
    flyoutContext.handleCloseFlyout();
  };

  const handleDescriptionChange = (event: ChangeEvent<HTMLInputElement>) => {
    setResourceDescription(event.target.value);
    setCanSubmit(true);
  };

  const handleNameChange = (event: ChangeEvent<HTMLInputElement>) => {
    setResourceName(event.target.value);
    setCanSubmit(true);
  };

  const handleIsPrivateChange = (event: ChangeEvent<HTMLInputElement>) => {
    setResourceIsPrivate(event.target.checked);
    setCanSubmit(true);
  };

  return (
    <>
      <div>
        <div>
          <div className="form-group row">
            <label htmlFor="name" className="col-2 col-form-label">Name: </label>
            <input id={"name"} data-testid="member-set-edit-resource-flyout__name" type="text" className="col-4 form-control" value={resourceName} onChange={handleNameChange} />
          </div>

          <div className="form-group row">
            <label htmlFor="description" className="col-2 col-form-label">
              Description:
            </label>
            <input id="description" data-testid="member-set-edit-resource-flyout__description" type="text" className="col-4 form-control" value={resourceDescription} onChange={handleDescriptionChange} />
          </div>
          <div className="form-group row">
            <div className="col-8 offset-2 pl-0">
              <QESCheckbox
                containerClassName="checkbox align-self-center"
                label="This is a Private Member Population (can be administered only by you)"
                id="isPrivate"
                testId="member-set-edit-resource-flyout__private"
                value="isPrivate"
                checked={resourceIsPrivate}
                onChange={handleIsPrivateChange}
              />
            </div>
          </div>
        </div>
      </div>
      <FlyoutFooter
        submitButton={<QESButton qesTestId="member-set-edit-resource-flyout_submit" disabled={!canSubmit} className="mb-3" onClick={handleSubmit}>Submit</QESButton>}
      />
    </>
  );
};

export default MemberSetEditResourceFlyout;
